import { useMemo } from "react";
import { Box } from "@chakra-ui/react";

const PixelGrid = ({ cols = 10, rows = 8 }) => {
  const cells = useMemo(() => {
    const result = [];
    for (let i = 0; i < rows * cols; i++) {
      const isHidden = Math.random() > 0.3;
      result.push({
        id: i,
        isHidden,
      });
    }
    return result;
  }, [cols, rows]);

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="grid"
      gridTemplateColumns={`repeat(${cols}, 1fr)`}
      gridTemplateRows={`repeat(${rows}, 1fr)`}
      gap={0}
      pointerEvents="none"
      zIndex={2}
    >
      {cells.map((cell) => (
        <Box
          key={cell.id}
          backgroundColor={cell.isHidden ? "#222222" : "transparent"}
          border="0.5px solid rgba(0, 0, 0, 0.3)"
          boxSizing="border-box"
        />
      ))}
    </Box>
  );
};

export { PixelGrid };
